import { Policy } from "@mui/icons-material";

export default function PermissionsAvatar() {
    return <Policy fontSize="large" />;
}